import Condiment from "./Condiment";

export default Condiment;
